/* eslint-disable max-lines */
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Container from '@material-ui/core/Container';
import LinearProgress from '@material-ui/core/LinearProgress';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Toolbar from 'components/Layout/Toolbar';
import { DateRange } from 'components/Shared/DateRanger';
import EmptyList from 'components/Shared/EmptyList';
import ErrorMessage from 'components/Shared/ErrorMessage';
import Snackbar from 'components/Shared/Snackbar';
import { IDocument } from 'interfaces/document';
import { IEntity } from 'interfaces/entity';
import { statuses } from 'interfaces/file';
import { IAppRoute } from 'interfaces/route';
import React, { PureComponent } from 'react';
import RxOp, { ICacheResult } from 'rxjs-operators';
import authService from 'services/auth';
import documentService from 'services/document';
import entityService from 'services/entity';
import selectedVentureService, { ISelection } from 'services/profile';

import rxjsOperators from '../../../../rxjs-operators';
import TabBar from './AreaBar';
import FilesList from './Files';
import Filter from './Filter';

interface IState {
  areaGraph?: IEntity;
  documents: IDocument[];
  filtered: IDocument[];
  error?: any | null;
  loading?: boolean;
  term?: string;
  startDate?: Date;
  endDate?: Date;
  status?: statuses[];
  selectedVenture: ISelection;
}

interface IProps {
  history: any;
  match?: any;
  classes?: any;
}
class Entity extends PureComponent<IProps, IState> {
  public static routes: IAppRoute[];
  timeoutTerm: any;
  tabComponentRef = React.createRef<TabBar>();

  constructor(props: IProps) {
    super(props);
    this.state = {
      documents: [],
      filtered: [],
      error: null,
      term: '',
      startDate: null,
      endDate: null,
      status: null,
      selectedVenture: null
    };
  }

  componentDidMount() {
    this.loadData();
  }

  warn = (message: string) => {
    Snackbar.show(message).finally(() => this.props.history.push('/'));
  };

  handleError = (error: any) => {
    Snackbar.error(error);
    this.setState({ error: { ...error.data, status: error.status }, loading: false });
    if (error.status === 423) authService.logout(false).subscribe(() => this.props.history.push('/'));
  };

  reorderDocuments = (document: IDocument, upOrDown: '+' | '-') => {
    documentService.reorder({
      id: document.id,
      upOrDown
    }).pipe(
      rxjsOperators.logError(),
      rxjsOperators.bindComponent(this)
    ).subscribe((document: any) => {
      Snackbar.show('Documentos reordenados com sucesso!');
      this.loadData();
    }, err => {
      Snackbar.error(err.message);
      this.setState({ loading: false });
    });
  };

  loadData = (entityId?: number) => {
    this.setState({ loading: true });
    const wantedEntityId = entityId || this.props.match.url.split('/').pop();
    const regex = /\/venture\/(\d+)\/entity/;
    const match = this.props.match.url.match(regex);
    const oldVenture = match[1];

    if (isNaN(wantedEntityId)) return;

    selectedVentureService
      .getSelectedVenture()
      .pipe(RxOp.logError(), RxOp.bindComponent(this))
      .subscribe(
        (selectedVenture) => {
          if (selectedVenture) {
            this.setState({ selectedVenture });
            entityService
              .fetchEntitiesGraph(selectedVenture.id)
              .pipe(RxOp.logError(), RxOp.bindComponent(this))
              .subscribe(
                (graph) => {
                  if (!(selectedVenture && graph))
                    return this.props.history.push('/');
                  const { id } = selectedVenture;

                  if (entityId) {
                    this.props.match.params.entityId = entityId;
                    this.props.history.replace({
                      pathname: `/documentation/files/venture/${id}/entity/${entityId}`,
                    });
                  }
                  this.listEntities(
                    id,
                    Number(wantedEntityId).valueOf(),
                    graph,
                    oldVenture
                  );
                },
                (error) => this.handleError(error)
              );
          }
        },
        (error) => this.handleError(error)
      );
  };

  listEntities = (id: number, entityId: number, graph: ICacheResult<IEntity[]>, oldVenture?: number) => {
    const { term, status, startDate, endDate } = this.state;
    documentService.listBy({
      page: 0,
      pageSize: Number.MAX_SAFE_INTEGER,
      orderBy: 'order',
      orderDirection: 'asc',
      term,
      status,
      startDate: startDate ? startDate.toISOString().split('T')[0] : null,
      endDate: endDate ? endDate.toISOString().split('T')[0] : null
    }, id, entityId)
      .pipe(RxOp.bindComponent(this))
      .subscribe(documents => {
        if (graph.data) {
          const areaGraph = graph.data.find(
            ({ id }) => id === entityId
          );

          if (!areaGraph) {
            entityService.fetchEntitiesGraph(oldVenture).subscribe((data) => {
              console.log({ data, oldVenture, entityId });

              const { name: entityName } = data.data.find(
                (entity) => entity.id === entityId
              );
              const newEntityAreaGraph = graph.data.find(
                ({ name }) => name === entityName
              );
              if (!newEntityAreaGraph) {
                return this.warn('Área não encontrada');
              }
              this.loadData(newEntityAreaGraph.id);
            });
            return;
          }
          const tabIndex = this.tabComponentRef.current ? this.tabComponentRef.current.state.value : 0;

          const children = areaGraph.children.filter(child =>
            child.ventureId ===
              this.state.selectedVenture.id || child.ventureId === null
          )[tabIndex];

          const tabId = children ? children.id : 0;
          if (tabId) {
            const subTabId = children.children.length ? children.children[0].id : undefined;
            const tabFiltered = documents.results.filter(doc => doc.tabId === tabId);
            const filtered = subTabId
              ? tabFiltered.filter(doc => doc.subTabId === subTabId)
              : tabFiltered;
            this.setState({
              areaGraph,
              documents: documents.results,
              filtered,
              loading: false,
            });
          } else {
            this.setState({
              areaGraph,
              documents: documents.results,
              filtered: [],
              loading: false,
            });
          }

        }
      }, error => this.handleError(error));
  };

  updateTabSelection = () => {
    const { areaGraph } = this.state;
    if (!areaGraph) return;

    const tabIndex = this.tabComponentRef.current.state.value;
    const subTabIndex = this.tabComponentRef.current.state.subTabValue;

    const tab = areaGraph.children
      .filter(child =>
        child.ventureId ===
      this.state.selectedVenture.id || child.ventureId === null
      )[tabIndex];

    if (!tab) return;
    const tabFilteredDocuments = this.state.documents.filter(doc => doc.tabId === tab.id);
    const subTab = tab.children[subTabIndex];
    const filtered = subTab
      ? tabFilteredDocuments.filter(doc => doc.subTabId === subTab.id)
      : tabFilteredDocuments;

    if (subTab) {
      const hasNullSubTab = tabFilteredDocuments.find(doc => !doc.subTabId);
      if (hasNullSubTab) Snackbar.error(`O documento '${hasNullSubTab.name}' não está associado a nenhuma Subaba.`);
    }

    this.setState({ filtered });
  };

  handleChangeTerm = (term: string) => {
    if (this.state.loading) return;

    this.setState({ term });
    clearTimeout(this.timeoutTerm);

    if (term && term.length < 3) return;

    this.timeoutTerm = setTimeout(() => this.loadData(), 500);
  };

  handleChangeDate = ([startDate, endDate]: DateRange<Date>) => {
    if (this.state.loading || (startDate && !endDate)) return;
    this.setState({ startDate, endDate });
    clearTimeout(this.timeoutTerm);

    this.timeoutTerm = setTimeout(() => this.loadData(), 500);
  };

  handleChangeStatus = (value?: statuses[]) => {
    this.setState({ status: value });
    clearTimeout(this.timeoutTerm);

    this.timeoutTerm = setTimeout(() => this.loadData(), 500);
  };

  render() {
    const { areaGraph: graph, filtered, error, loading, term, startDate, endDate, status } = this.state;
    const title = (graph && graph.name) || 'Módulos';
    const breadcrumbs = [
      { title: 'Módulos' },
    ];
    if (graph && graph.name) breadcrumbs.push({ title: graph.name });

    return (
      <>
        <Toolbar title={title} breadcrumbs={breadcrumbs} />
        <Container>
          <Filter
            term={term}
            handleChangeTerm={this.handleChangeTerm}
            date={[startDate, endDate]}
            handleChangeDate={this.handleChangeDate}
            status={status}
            handleChangeStatus={this.handleChangeStatus}
          />
          {!error && graph && (
            <>
              <TabBar entityGraph={graph} ref={this.tabComponentRef} onChange={this.updateTabSelection} />
              <Card>
                {error && <ErrorMessage error={error} tryAgain={this.loadData} />}
                {loading && <LinearProgress color="secondary" />}
                <CardContent>
                  <List>
                    {filtered.length ? filtered.map((document, idx) => (
                      <ListItem key={`${document.id}-${document.name}`} divider disableGutters>
                        <FilesList
                          startDate={startDate}
                          endDate={endDate}
                          document={document}
                          currentIndex={idx}
                          lastIndex={filtered.length - 1}
                          onClickReorder={this.reorderDocuments}
                        />
                      </ListItem>
                    )) : (
                      <EmptyList message="Nenhum documento cadastrado." />
                    )}
                  </List>
                </CardContent>
              </Card>
            </>
          )}
        </Container>
      </>
    );
  }
}

export default Entity;